var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"test-home"},[_c('div',[(_vm.infoData.id && _vm.infoData.style==2)?_c('TestStyleTwo'):_c('TestStyleOne')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }